import React, { FC } from 'react';

import styled from 'styled-components';

import CloseButton from 'components/close-button';
import Modal from 'components/modal';
import { SetLoyaltyCardRewardsTierMutationHookResult } from 'generated/rbi-graphql';

import RewardCategories from '.';

import { Background } from '..';

const ModalCloseButton = styled(CloseButton)`
  left: calc(1.25rem + env(safe-area-inset-left));
  position: fixed;
  top: calc(1rem + env(safe-area-inset-top));
  z-index: ${Styles.zIndex.below};
  color: ${Styles.color.white};
  background: transparent;
`;

const RewardCategoriesContainer = styled.div`
  padding: 100px 1.25rem 55px;
`;

const AllModalContent = styled.div`
  background-color: white;
  width: 100%;
  height: 100%;
`;

interface IRewardCategoriesModalProps {
  onDismiss: () => void;
  radioButtonName: string;
  setSelectedRewardsTier: SetLoyaltyCardRewardsTierMutationHookResult[0];
}

export const RewardCategoriesModal: FC<IRewardCategoriesModalProps> = ({
  onDismiss,
  radioButtonName,
  setSelectedRewardsTier
}) => (
  <Modal
    closeButton={ModalCloseButton}
    onDismiss={onDismiss}
    mParticleEventData={{ modalAppearanceEventMessage: 'Reward Categories' }}
  >
    <AllModalContent>
      <Background>
        <RewardCategoriesContainer>
          <RewardCategories
            radioButtonName={radioButtonName}
            setSelectedRewardsTier={setSelectedRewardsTier}
          />
        </RewardCategoriesContainer>
      </Background>
    </AllModalContent>
  </Modal>
);
